import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import CardMedia from "@material-ui/core/CardMedia";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import VisibilityIcon from '@material-ui/icons/Visibility';
import { swalSubmit } from "../../shared/swalSubmit";
import * as actions from "../../store/actions/index";
import * as headers from "../../shared/language.json";
import axiosConfig from "../../axiosConfig";
import logo from "../../assets/images/ehealth.png";

function SetYourPassword(props) {
  const [showPassword, setShowPassword] = useState(false);
  let history = useHistory();

  const handleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const formik = useFormik({
    initialValues: {
      TempPassword: "",
      NewPassword: "",
      VerifyPassword: "",
      email: props.location.email ? props.location.email : "",
    },
    validationSchema: Yup.object({
      TempPassword: Yup.string().required(headers.FORMIKERRORMESSAGES.REQUIRED),
      NewPassword: Yup.string().required(headers.FORMIKERRORMESSAGES.REQUIRED),
      VerifyPassword: Yup.string().oneOf(
        [Yup.ref("NewPassword"), null],
        headers.FORMIKERRORMESSAGES.PASSWORDSMUSTMATCH
      ),
      email: Yup.string().email().required(headers.FORMIKERRORMESSAGES.REQUIRED),
    }),
    onSubmit: (values) => {
      Swal.fire(swalSubmit).then((result) => {
        if (result.value) {
          axiosConfig
            .put(`/User/ChangeTemporaryPassword`, {
              previousPassword: values.TempPassword,
              newPassword: values.NewPassword,
              verifyNewPassword: values.VerifyPassword,
              email: values.email
            })
            .then((res) => {
              if (res.status === 200) {
                Swal.fire("Η αλλαγή κωδικού ήταν επιτυχής", "", "success");
                props.setPassword(false);
              } else {
                Swal.fire("Η καταχώρηση ήταν ανεπιτυχής", "", "error");
              }
              return res;
            })
            .then((res) => {
              if (res.status === 200) {
                history.push("/login");
              }
            })
            .catch((err) => {
              Swal.fire("Η καταχώρηση ήταν ανεπιτυχής", "", "error");
              console.log(err);
            });
        }
      });
    },
  });

  return (
    <Grid
      container
      alignItems="center"
      justify="center"
      spacing={2}
      direction="column"
      style={{
        minHeight: '100vh'
      }}
    >
      <CardMedia>
        <img
          width="50%"
          src={logo}
          alt="ehealth logo"
        />
      </CardMedia>
      <Grid item xs={12} >
        <Typography component="h1" variant="h6" align="left">
          Εισάγετε τον νέο Κωδικό
        </Typography>
        <Divider />
      </Grid>
      <Grid container direction="column" alignContent="center" spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            id="email"
            name="email"
            label="Email"
            type="email"
            disabled = {props.location.email ? true :false}
            fullWidth
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
          />
          {formik.touched.email && formik.errors.email ? (
            <span style={{ color: "red" }}>{formik.errors.email}</span>
          ) : null}
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="TempPassword"
            name="TempPassword"
            label="Προσωρινός Κωδικός Χρήστη"
            type="password"
            fullWidth
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.TempPassword}
          />
          {formik.touched.Password && formik.errors.Password ? (
            <span style={{ color: "red" }}>{formik.errors.Password}</span>
          ) : null}
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="NewPassword"
            name="NewPassword"
            label="Νέος Κωδικός Χρήστη"
            type={showPassword ? "text" : "password"}
            fullWidth
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.NewPassword}
            InputProps={{
              endAdornment: (
                <Button onClick={handleShowPassword}>
                  <VisibilityIcon />
                </Button>
              )
            }}
          />
          {formik.touched.NewPassword && formik.errors.NewPassword ? (
            <span style={{ color: "red" }}>{formik.errors.NewPassword}</span>
          ) : null}
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="VerifyPassword"
            name="VerifyPassword"
            label="Επιβεβαίωση Κωδικού Χρήστη"
            type="password"
            fullWidth
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.VerifyPassword}
          />
          {formik.touched.VerifyPassword && formik.errors.VerifyPassword ? (
            <span style={{ color: "red" }}>{formik.errors.VerifyPassword}</span>
          ) : null}
        </Grid>

        <Grid item sm={12} style={{ textAlign: "center", marginTop: "16px" }}>
          <Button
            type="button"
            variant="contained"
            color="primary"
            onClick={formik.handleSubmit}
          >
            Αποθηκευση
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}
const mapDispatchToProps = (dispatch) => {
  return {
    authorize: (isAuthBool) => {
      dispatch(actions.authorizeValidation(isAuthBool));
    },
    setLoginValidationUIForm: (validationPayload) => {
      dispatch(actions.setValidationUILoginForm(validationPayload));
    },
    municipalityMapState: (id) => {
      dispatch(actions.setMunicipalityId(id));
    },
    setIsReloaded: () => {
      dispatch(actions.setIsReloaded());
    },
    setPassword: (isPrimaryBool) => {
      dispatch(actions.setPassword(isPrimaryBool));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    controls: state.loginValidationUI.controls,
    formIsValid: state.loginValidationUI.formIsValid,
    componentIds: state.auth.componentIds,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SetYourPassword);
